var render = function render(){var _vm=this,_c=_vm._self._c;return _c('general-text-field',{attrs:{"label":"Text","dense":"","autofocus":"","disabled":_vm.isImmutable},model:{value:(_vm.$_text),callback:function ($$v) {_vm.$_text=$$v},expression:"$_text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }